<label for="inputtext">{{textField.categorieChantId}}</label>
<p-dropdown [options]="categoryCeService.categoryDataList" [(ngModel)]="objChant.categorieChantId"  [formControl]="control"  [itemSize]="10"
  [virtualScroll]="false" [filter]="false" [checkmark]="true" optionValue="code" optionLabel="nom"
  styleClass="w100"  placeholder=" -Select {{textField.categorieChantId}} -" [loading]="categoryCeService.loadingCategoryDataList">
  <ng-template let-option  pTemplate="selectedItem">
    <div class="ofa" pTooltip="{{option.code}}-{{option.nom}}" tooltipPosition="bottom">
      {{option.nom}} </div>
  </ng-template>
  <ng-template let-option pTemplate="item">
    <span>@if(option.code!=''){[{{option.code}}] : } {{option.nom}} </span>
  </ng-template>
</p-dropdown>
